module.exports = __webpack_public_path__ + "img/imge8.84cd5a5b.png";